import { render } from "./WhenThingsGoWrong.vue?vue&type=template&id=8c8968f8"
import script from "./WhenThingsGoWrong.vue?vue&type=script&lang=js"
export * from "./WhenThingsGoWrong.vue?vue&type=script&lang=js"

import "./WhenThingsGoWrong.vue?vue&type=style&index=0&id=8c8968f8&lang=scss"

import exportComponent from "/opt/build/repo/sleeper-trader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__